//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'EquipmentControl',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/online/deviceOnlineStatus',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      addDisabled: false,
      photo: '',

      /* 数据源 */
      dataSource: [],
      // 表头
      columns: [],

      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      }
    };
  },
  created: function created() {},
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    },
    carChange: function carChange(assetId, siteId) {
      this.$bus.$emit('showProject', 'show', false), this.$bus.$emit('showSite', 'show', false), this.$router.push({
        path: '/monitor/EquipmentControlList',
        query: {
          assetId: assetId,
          scopeId: siteId
        }
      });
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.pagePath, params).then(function (res) {
        if (res.success) {
          var list = [];

          for (var i = 0; i < res.result.length; i++) {
            var equipmentData = res.result[i];
            equipmentData.key = equipmentData.id;
            equipmentData.photo = _this.getImageView(equipmentData.photo);
            if (equipmentData.insideName != undefined && equipmentData.insideName != '') equipmentData.name = equipmentData.insideName;
            list.push(equipmentData);
          }

          _this.dataSource = list;
          _this.ipagination.total = res.result.total;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }

        _this.loading = false;
      });
    },
    handleTableChange: function handleTableChange(pagination, filters) {
      this.ipagination.current = pagination;
      this.ipagination.pageSize = filters;
      this.loadData();
    },
    loadData: function loadData(arg) {
      this.initTableData(arg);
    }
  }
};